import React, { useEffect, useState } from 'react';
import { MdDelete, MdOutlineNotificationsOff } from 'react-icons/md';
import { SuccessAlert } from '../alert/SuccessAlert';
import { colorTheme } from '../../utilities/ColorTheme';
import { convertUTCDateToLocalDateStringFormat } from '../../utilities/DateTimeToLocalDateTime';
import './style.css';
import { WarningAlert } from '../alert/WarningAlert';
import { BASE_URL, Endpoints } from '../../constants/urls';
import { AiFillEdit } from 'react-icons/ai';
import axios from 'axios';
export function PastEventList({
  setAnnouncementModal,
  setUpdateNotificationsList,
  showPastEventModal,
  setShowPastEventModal,
  showEventRecordingModal,
}) {
  const [alert, setAlert] = useState(false);

  const [deleteAlert, setDeleteAlert] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPastEvents();
  }, [showPastEventModal, showEventRecordingModal]);
  const fetchPastEvents = async () => {
    const url = BASE_URL + Endpoints.GetPastEvents;
    try {
      const response = await axios.get(url);
      setEvents(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const onPressDelete = async (item) => {
    setLoading(true);
    try {
      const url = BASE_URL + Endpoints.DeleteEvent;
      const eventData = {
        id: selectedItem.id,
      };
      const response = await axios.post(url, null, {
        params: eventData,
      });
      setDeleteSuccess(true);
      setSelectedItem(undefined);
      fetchPastEvents();
    } catch (err) {}
    setLoading(false);
  };
  const onEditData = (item) => {
    setUpdateNotificationsList(item);
    setShowPastEventModal(true);
  };

  return (
    <>
      {events?.length > 0 ? (
        <table id='contact-grid'>
          <thead>
            <tr>
              <th>Topic</th>
              <th>Speaker Name</th>
              <th>Event Date</th>
              <th>Created Date </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {events?.map((item, i) => (
              <tr key={i}>
                <td>
                  <div className='two-line-elp'>{item.title}</div>
                </td>
                <td>
                  <div className='two-line-elp'>{item.speakerName}</div>
                </td>
                <td>
                  {convertUTCDateToLocalDateStringFormat(item.date, true)}
                </td>

                <td>
                  {convertUTCDateToLocalDateStringFormat(item.createdDate)}
                </td>
                <td>
                  <button
                    onClick={() => {
                      setUpdateNotificationsList(item);
                      setAnnouncementModal(true);
                    }}
                    style={{ height: 30, fontSize: 10, marginLeft: 10 }}
                    className='reidPrimaryBtn btn'
                  >
                    <span style={{ fontSize: 13 }}>Add Recordings</span>
                  </button>
                  <span
                    className='pointer-hover'
                    style={{ marginLeft: 10 }}
                    onClick={() => onEditData(item)}
                  >
                    <AiFillEdit color={colorTheme.primaryBlue} />
                  </span>
                  <span
                    className='pointer-hover'
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                      setDeleteAlert(true);
                      setSelectedItem(item);
                    }}
                  >
                    <MdDelete color='#e02a2a' size={18} />
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className=' d-flex justify-content-center align-items-center'>
          <div style={{ color: colorTheme.inputBorder }}>
            <MdOutlineNotificationsOff size={150} style={{ marginLeft: 20 }} />
            <p className='not_found_text'>No Past Event Found</p>
          </div>
        </div>
      )}
      {deleteAlert && (
        <WarningAlert
          message={'Do you want to delete this Event?'}
          onCancel={() => setDeleteAlert(false)}
          ondelete={() => onPressDelete()}
        />
      )}
      {alert && (
        <SuccessAlert
          message='Event status updated successfully.'
          onClose={() => setAlert(false)}
        />
      )}
      {deleteSuccess && (
        <SuccessAlert
          message='Event deleted successfully.'
          onClose={() => setDeleteSuccess(false)}
        />
      )}
    </>
  );
}
